<template>
  <AppTimeZoneDropdown
    :active="activeTimeZone"
    :options="timeZoneOptions"
    :tooltip-options="tooltipOptions"
    :direction="direction"
    @input="changeTimeZone"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import AppTimeZoneDropdown from '~/components/AppTimeZoneDropdown.vue';

export default {
  name: 'InsightsHeaderTimeZoneFilter',
  components: { AppTimeZoneDropdown },
  props: {
    direction: {
      type: String,
      default: 'left',
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ container: 'body' }),
  }),
  computed: {
    ...mapGetters(['activeTimeZone', 'timeZoneOptions']),
  },
  methods: {
    changeTimeZone(tzParam) {
      this.$emit('input', tzParam);
    },
  },
};
</script>
